import format from "date-fns/format";

export default dateTime =>
  dateTime ? format(dateTime, "yyyy-MM-dd HH:mm:ss") : "N/A";
